import { AuthRoutes } from '@vs/oidc-client';
import { toggleSessionExpired } from '@vs/rtk/slices/genericGlobal';
import { useAuthOmitPaths } from '@vs/shared-context/spa-path-config-provider';
import { PortalBackdrop } from '@vs/ui/portal/backdrop';

import { useAppDispatch } from '../../redux/hooks';
import AppContentInit from '../AppContentInit';

export default function AppAuthRoutes() {
  const dispatch = useAppDispatch();
  const authOmitPaths = useAuthOmitPaths();

  function showSessionExpired() {
    dispatch(toggleSessionExpired(true));
  }

  return (
    <AuthRoutes
      renderLoadingUI={() => <PortalBackdrop type="app_init" open />}
      renderComponent={() => <AppContentInit />}
      propsAuthGuard={{
        generateSignInState: () => ({ vs_client_name: 'account' }),
        authOmitPaths,
        onTokenRefreshError: showSessionExpired,
        onLogout: showSessionExpired,
      }}
    />
  );
}
